<template>
  <div class="datetimeGroup" @click="setPopover">
    <div class="datetime" :style="flexStyle(itemSetting.layout.flex)">
      <div v-if="itemSetting.action.asap.active" :style="{opacity: value.type === 'asap' ? 1 : 0.7, flex: itemData.column[0].flex}" class="vdatetime setbox">
        <input type="radio" :name="`datetime_${id}`" :id="`datetime_${id}_asap`" value="asap" v-model="value.type">
        <label :for="`datetime_${id}_asap`" :style="setDetailStyle(itemData.column[0].detail)" class="btn btnFull">
          <span v-html="itemData.column[0].value[lang]"></span>
        </label>
      </div>
      <div v-if="itemSetting.action.settime.active" :style="{opacity: value.type === 'settime' ? 1 : 0.7, flex: itemData.column[1].flex}" class="vdatetime setbox isPopover">
        <input type="radio" :name="`datetime_${id}`" :id="`datetime_${id}_settime`" value="settime" v-model="value.type">
        <label :for="`datetime_${id}_settime`" :style="setDetailStyle(itemData.column[1].detail)" class="btn btnFull">
          <span v-html="itemData.column[1].value[lang]"></span>
        </label>
      </div>
    </div>
    <div v-if="itemSetting.action.settime.active" v-show="value.type === 'settime'" class="mt5">
      <p v-if="!passed" class="requiredMessage">{{locale.message_required_datetime}}</p>
      <div class="datetime">
        <!-- calendar 모듈의 datepicker 플러그인으로 변경 -->
        <div v-if="itemSetting.action.activeDate !== false" class="vdatetime datetimeDate">
          <vc-date-picker class="notranslate"
            v-model="dateTimeData.date"
            mode="date"
            :masks="{input: dateFormat.toUpperCase()}"
            :value="null"
            :disabled-dates="disabledDates"
            :attributes="calendarAttr"
            :locale="ln"
            @popoverWillShow="setPopover"
            @afterHide="setPopover">
            <template v-slot="{ inputValue, togglePopover }">
              <div>
                <button
                  class="btn btnWhite btnFull btnCalendar"
                  @click="togglePopover()">
                  <span class="dateLabel">{{inputValue || '-'}}</span>
                </button>
              </div>
            </template>
          </vc-date-picker>
        </div>
        <!-- //calendar 모듈의 datepicker 플러그인으로 변경 -->
        <div v-if="itemSetting.action.activeTime !== false" class="vdatetime datetimeTime">
          <div class="input">
            <vc-date-picker class="notranslate"
              v-model="dateTimeData.time"
              mode="time"
              :valid-hours="validHours"
              :minute-increment="minuteIncrement"
              is24hr />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { DateTime } from 'luxon'
import moment from 'moment/moment'
import regExp from '@/common/regExp'

export default {
  name: 'Datetime',
  props: [
    'id',
    'locale',
    'itemData',
    'itemSetting',
    'lang',
    'storageData',
    'getPage',
    'getSubmitData'
  ],
  computed: {
    ...mapGetters({
      dateFormat: 'common/getDateFormat'
    }),
    ln () {
      return this.$route.params.ln
    },
    availableTable () {
      return this.getPage.available.set
    },
    minuteStep () {
      return parseInt(this.itemSetting.action.settime.time)
    },
    timezone () {
      return this.$store.state.siteInfo.timezoneId || ''
    },
    datetimeLocale () {
      return require(`vue2-datepicker/locale/${this.lang.toLowerCase()}.js`)
    },
    value () {
      const data = typeof (this.getSubmitData.find(x => x.id === this.id)) === 'undefined'
        ? ''
        : this.getSubmitData.find(x => x.id === this.id).value
      return data
    },
    getAvailableDay () {
      return this.$store.getters['util/getAvailableDay']
    },
    guestInfo () {
      return this.$store.getters['guest/getGuestInfo']
    },
    disabledDates () {
      const weekday = this.itemSetting.action.dayOfWeek ? this.itemSetting.action.dayOfWeek.filter(x => !x.available).map(x => x.weekday) : []
      const hasTerm = this.itemSetting.action.hasTerm
      const disabledDays = this.itemSetting.action.disabledDays ? this.itemSetting.action.disabledDays.map(x => x.id) : []
      const allowedToday = this.itemSetting.action.allowedToday !== false
      const allowedPast = this.itemSetting.action.allowedPast !== false
      const allowedStay = this.itemSetting.action.allowedStay
      const today = moment() // today로 계산할 경우 moment() 계산이 아닌 today가 계속 변경되므로 쓰지말것
      const dateFrom = moment(this.itemSetting.action.dateFrom)
      const hasRangeDay = this.itemSetting.action.hasRangeDay
      const guestInfo = this.guestInfo
      const stayBefore = guestInfo && guestInfo.stayBefore
      const stayAfter = guestInfo && guestInfo.stayAfter
      const rangeDayNumber = Number(regExp.numberOnly(this.itemSetting.action.rangeDayNumber || 30))
      const rangeFrom = allowedPast // 과거 선택 가능?
        ? hasTerm // 과거 선택 가능 + 기간 설정
          ? dateFrom.add(-1, 'days')
          : null
        : hasTerm // 과거 선택 불가 + 기간 설정
          ? moment().isAfter(dateFrom, 'days') // 오늘 지남?
            ? moment().add(-1, 'days')
            : dateFrom.add(-1, 'days')
          : moment().add(-1, 'days')
      const rangeTo = moment(this.itemSetting.action.dateTo).add(1, 'days')
      let dates = [{ weekdays: weekday }]
      if (allowedStay && stayAfter && stayBefore) { // 투숙기간만
        dates.push({
          start: null,
          end: moment(stayAfter).add(-1, 'days').endOf('day').toISOString()
        })
        dates.push({
          start: moment(stayBefore).add(1, 'days').startOf('day').toISOString(),
          end: null
        })
      }
      if (!allowedPast || hasTerm) {
        dates.push({
          start: null,
          end: rangeFrom.toISOString()
        })
      }
      if (hasTerm) {
        dates.push({
          start: rangeTo.toISOString(),
          end: null
        })
      }
      if (hasRangeDay) {
        dates.push({
          start: moment().add(rangeDayNumber + 1, 'days').toISOString(),
          end: null
        })
      }
      if (disabledDays.length) {
        disabledDays.forEach(function (x) {
          dates.push(new Date(x))
        })
      }
      if (!allowedToday) {
        dates.push(new Date())
      }
      return dates
    },
    validHours () {
      const rangeTime = this.itemSetting.action && this.itemSetting.action.rangeTimeNumber
      return rangeTime
        ? rangeTime.filter(x => x.active).map(x => parseInt(x.value))
        : null
    },
    minuteIncrement () {
      const unit = this.itemSetting.action.minuteUnit || this.itemSetting.action.settime.time
      return parseInt(unit)
    },
    passed () {
      return this.getSubmitData && this.getSubmitData.find(x => x.id === this.id)
        ? this.getSubmitData.find(x => x.id === this.id).passed
        : null
    }
  },
  watch: {
    value: {
      deep: true,
      handler (value) {
        if (value) {
          const datetime = this.dateTimeData
          const isSettime = value.type === 'settime'
          const activeDate = this.itemSetting.action.activeDate !== false
          const activeTime = this.itemSetting.action.activeTime !== false
          const passed = isSettime ? (activeDate ? datetime.date !== null : true) && (activeTime ? datetime.time !== null : true) : true
          const data = {
            id: this.id,
            value: value,
            passed: passed
          }
          this.$emit('setValue', data)
        }
      }
    },
    dateTimeData: {
      deep: true,
      handler (datetime) {
        const value = this._.cloneDeep(this.value)
        const isSettime = value.type === 'settime'
        const time = datetime.time
        const hour = moment(time).get('hour')
        const minute = moment(time).get('minute')
        const activeDate = this.itemSetting.action.activeDate !== false
        const activeTime = this.itemSetting.action.activeTime !== false
        const passed = isSettime ? (activeDate ? datetime.date !== null : true) && (activeTime ? datetime.time !== null : true) : true
        const data = {
          id: this.id,
          value: {
            ...value,
            settime: moment(datetime.date || datetime.time).set({ hour: hour, minute: minute, second: 0 }).tz(this.timezone).toISOString(),
            ...value.type === 'settime' && {
              ...(activeDate && !activeTime) && {
                datetimeOnly: 'date'
              },
              ...(activeTime && !activeDate) && {
                datetimeOnly: 'time'
              }
            }
          },
          passed: passed
        }
        this.$emit('setValue', data)
      }
    }
  },
  // beforeDestroy () {
  //   window.removeEventListener('click', this.setPopover)
  // },
  // created () {
  //   window.addEventListener('click', this.setPopover)
  // },
  mounted () {
    // this.dateTimeData
    // const today = moment()
    // const disabledDates = this.disabledDates
  },
  data () {
    return {
      dateTimeData: {
        date: null,
        time: null
      },
      calendarAttr: [
        {
          bar: 'orange',
          dates: moment().toDate()
        }
      ]
    }
  },
  methods: {
    flexStyle (style) {
      if (style) {
        return {
          alignItems: style.alignItems
        }
      }
    },
    setDetailStyle (detailData) {
      const notStyles = ['options']
      const styles = Object.keys(detailData).filter(function (o) {
        return notStyles.indexOf(o) === -1
      })
      const styleObj = {}
      styles.forEach(function (x) {
        const obj = detailData[x]
        if (obj && obj.active) {
          let key = ''
          let value = ''
          switch (x) {
            case 'background':
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'border':
              styleObj['border-width'] = '1px'
              Object.keys(obj).forEach(function (o) {
                key = `${x}-${o}`
                value = obj[o]
                styleObj[key] = value
              })
              break
            case 'radius':
              styleObj['border-radius'] = `${obj.tl}px ${obj.tr}px ${obj.br}px ${obj.bl}px`
              break
            case 'text':
              styleObj.color = obj.color
              break
          }
        }
      })
      return styleObj
    },
    setPopover (isPopover) {
      this.$emit('setPopover', isPopover ? this.id : '')
    }
  }
}
</script>

<style lang="scss" scoped>
.datetime {
  position: relative;
  .displayDate {
    position: absolute;
    top: 1px;
    left: 8px;
    width: calc(50% - 8px);
  }
}
.requiredMessage {
  margin-left: 8px;
  font-size: 13px;
  &:before {
    content: "*";
    margin-right: 2px;
    color: $color-red;
  }
}
</style>
